import React from 'react';
import SvgIconLoader, {
  COLOR,
  SVG_ICON_KIND,
  ICONS_ID,
} from '@bitComponents/unifiedIcons/SvgIconLoader';

export default function Check() {
  return (
    <div className="waitingPageIconCheckContainer">
      <div>
        <SvgIconLoader
          id={ICONS_ID.Check}
          color={COLOR.BLUE_A}
          kind={SVG_ICON_KIND.MEDIUM}
          sizeCircular={30}
          size={36}
          className="waitingPageIconCheck"
        />
        <div className="waitingPageCheckShadow" />
      </div>
    </div>
  );
}
